/**
 * Inventory Stock Service - 业务逻辑层 + Mock 适配
 * 页面组件只调用此 Service 层,不直接调用 API
 */

import { config } from '../../config';
import * as inventoryMock from '../../mocks/inventory';
import httpClient from '../httpClient';
import { API_ENDPOINTS } from '../../utils/apiEndpoints';
import type { ApiResponse, PageData } from '../../types/common';
import type {
  InventoryDTO,
  QueryInventoryPageRequest,
  ExportInventoryRequest,
  CategoryOptionDTO,
} from '../../types/inventory/stock';

/** 分页查询库存列表 */
export async function pageInventory(
  params: QueryInventoryPageRequest
): Promise<ApiResponse<PageData<InventoryDTO>>> {
  if (config.mock) {
    return inventoryMock.mockPageInventory(params);
  }

  return httpClient.post(API_ENDPOINTS.INVENTORY.STOCK_PAGE, params);
}

/** 按SKU查询库存详情 */
export async function getInventoryBySku(
  sku: string
): Promise<ApiResponse<InventoryDTO>> {
  if (config.mock) {
    return inventoryMock.mockGetInventoryBySku(sku);
  }

  return httpClient.get(`${API_ENDPOINTS.INVENTORY.STOCK_BASE}/${sku}`);
}

/** 导出库存数据 */
export async function exportInventory(
  params: ExportInventoryRequest
): Promise<ApiResponse<string>> {
  if (config.mock) {
    return { success: true, data: '', errorMessage: null } as any;
  }
  return httpClient.post(API_ENDPOINTS.INVENTORY.STOCK_EXPORT, params);
}

/** 获取类目选项 */
export async function getCategoryOptions(): Promise<ApiResponse<CategoryOptionDTO[]>> {
  if (config.mock) {
    return inventoryMock.mockGetCategoryOptions();
  }

  return httpClient.post(API_ENDPOINTS.INVENTORY.CATEGORY_OPTIONS, {});
}
